import { render, staticRenderFns } from "./EmbroideryPositions.vue?vue&type=template&id=389b1209&"
import script from "./EmbroideryPositions.vue?vue&type=script&lang=js&"
export * from "./EmbroideryPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports